enum NewReservationScreenStep {
    Dates = 'Dates',
    Rates = 'Rates',
    Summary = 'Summary',
}

export default NewReservationScreenStep;
